import { useTranslation } from "react-i18next";
import TestSoundVideoFlow from "./TestSoundVideoFlow";

export default function TestSoundVideoScreen({
  standalone,
}: {
  standalone?: boolean;
}) {
  const { t } = useTranslation();

  return (
    <TestSoundVideoFlow
      standalone={standalone}
      backTo={`/`}
      parentName={t("Home")}
    />
  );
}
